<template>
    <v-card class="overflow-hidden clickable">
        <v-toolbar
                :color="color"
                dark
                flat
        >
            <v-toolbar-title class="grs-card-title px-0">
                {{ title }}
            </v-toolbar-title>
            <v-btn
                    small
                    icon
                    @click="fetchReports()"
            >
                <v-icon :class="{ 'mdi-spin' : loading }">mdi-cached</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <span>
                   {{$t('display_price', { price : $n(totalDue) })}}
                </span>

        </v-toolbar>
        <v-list dense active-class="pink--text">
            <v-list-item>
                <v-list-item-title>مالیات</v-list-item-title>
                <v-list-item-title class="text-left">
                    {{$t('display_price', { price : $n(totalDue - subTotal) })}}
                </v-list-item-title>
            </v-list-item>
            <v-list-item>
                <v-list-item-title>خالص دریافتی ({{paidCount}})</v-list-item-title>
                <v-list-item-title class="text-left">
                    {{$t('display_price', { price : $n(subTotal) })}}
                </v-list-item-title>
            </v-list-item>
            <v-list-item :active='true'>
                <v-list-item-title>ناموفق ({{count - paidCount}})</v-list-item-title>
                <v-list-item-title class="text-left">
                    {{$t('display_price', { price : $n(notPaidTotalDue) })}}
                </v-list-item-title>
            </v-list-item>
        </v-list>
        <v-card-actions
            v-if="false"
        >
            <v-btn
                    color="orange lighten-2"
                    text
            >
                نمایش رسید ها
            </v-btn>

            <v-spacer></v-spacer>
        </v-card-actions>
    </v-card>
</template>

<script>
    import Service from '../services/ReceiptsService';

    export default {
        props: {
            title: {
                type: String,
                default: 'مجموع ورودی'
            },
            filters: {
                default : () => []
            },
            color:{
                type: String,
                default: 'success'
            }

        },
        data() {
            return {
                loading: false,
                reports : []
            }
        },
        computed: {
            count() {
                return this.reports.reduce( (count,{total}) => parseInt(total) + count, 0);
            },
            paidCount() {
                return this.reports
                    .filter( (report) => report.status === 'paid' )
                    .reduce( (count, {total}) => parseInt(total) + count, 0);
            },
            subTotal() {
                return this.reports
                    .filter( (report) => report.status === 'paid' )
                    .reduce( (subTotal, {sub_total}) => parseInt(sub_total) + subTotal, 0);
            },
            totalDue() {
                return this.reports
                    .filter( (report) => report.status === 'paid' )
                    .reduce( (totalDue, {total_due}) => parseInt(total_due) + totalDue, 0);
            },
            notPaidTotalDue() {
                return this.reports
                    .filter( (report) => report.status !== 'paid' )
                    .reduce( (totalDue, {total_due}) => parseInt(total_due) + totalDue, 0);
            }
        },
        mounted() {
            this.fetchReports();
        },
        methods: {
            async fetchReports() {
                this.loading = true;
                try {
                    let {
                        data
                    } = await Service.getOverviewReport('yearly', this.filters);
                    this.reports = data.value.receipts_overview;
                } finally {
                    this.loading = false;
                }
            }
        }
    }
</script>